import React from "react";
import { Link } from "react-router-dom";

const ContactAddress = () => {
    return (
        <div className="contact-info-content">
            <div className="info-address">
                <h2 className="title">
                    정환교 <span>피부과 의원</span>
                </h2>
                <p>경기도 안산시 단원구 중앙대로 915 (고잔동, 월드코아) 5층</p>
                <div className="booking-btn-wrap">
                    <a
                        href="https://m.booking.naver.com/booking/13/bizes/1581590?theme=place&service-target=map-pc&lang=ko"
                        className="naver-booking-btn"
                    >
                        네이버 예약 (시술 상담)
                    </a>
                </div>
            </div>
            <div className="brand-office">
                <div className="info-tem style-two">
                    <h6>안내사항:</h6>
                    <p>
                        시술 상담(토닝, 흉터, 리프팅 등)만 네이버 예약이 가능합니다.<br />
                        일반 진료는 현장 접수만 가능하며 예약이 불가합니다.
                    </p>
                </div>
                <div className="info-tem">
                    <h6>오시는 방법:</h6>
                    <p>지하철 4호선 중앙역 2번 출구 도보 5분 | 버스 정류장: 중앙역 하차</p>
                </div>
                <div className="info-tem mb-0">
                    <h6>진료 시간:</h6>
                    <p>
                        월, 화, 목, 금: 06:30 - 15:30 (접수 조기마감)<br />
                        토요일: 05:30 - 10:30 (접수 조기마감)<br />
                        수요일, 일요일 휴무
                    </p>
                </div>
                <div className="info-tem mt-3">
                    <p className="no-reservation-text">
                        * 카톡 및 전화 예약은 운영하지 않습니다.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ContactAddress;
